import React from 'react'
import ChangelogInstance from '../ChangelogInstance';
const TwoDotOneDotTwo = () => {
  return (
    <ChangelogInstance version="2.1.2" date="2020-04-14">
      <li>Fixed the same issue as 2.1.1 but for all users (including users updating from 2.1 and 2.1.1</li>
    </ChangelogInstance>
  );
}

export default TwoDotOneDotTwo;